import { render, staticRenderFns } from "./FilesUploadLayer.vue?vue&type=template&id=136781cc&scoped=true&"
import script from "./FilesUploadLayer.vue?vue&type=script&lang=js&"
export * from "./FilesUploadLayer.vue?vue&type=script&lang=js&"
import style0 from "./FilesUploadLayer.vue?vue&type=style&index=0&id=136781cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136781cc",
  null
  
)

export default component.exports